module.exports = "<div *ngIf=\"showC\" class=\"alert {{'alert-'+type}}\" role=\"alert\">\n  <div class=\"pull-right\"><i class=\"fa fa-close\" (click)=\"onClose()\"></i></div>\n  <div>{{message}}</div>  \n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = main